import axios from 'axios';

/**
 * @typedef {object} App
 * @property {number} id
 * @property {string} name
 * @property {string} [iconUrl]
 */

export default {

  /**
   * @async
   * @param {object} fields
   * @param {string} fields.name
   * @param {string} [fields.iconUrl]
   * @returns {App}
   */
  async createApp(fields) {
    const options = {
      method: 'POST',
      baseURL: window.apiUrl,
      url: '/apps',
      data: fields,
      headers: {
        'Authorization': 'Bearer ' + localStorage.token
      }
    };
    const res = await axios.request(options);
    if (!res.data.success) {
      throw new Error(res.data.error);
    }
    return res.data.app;
  },

  /**
   * @async
   * @returns {App[]}
   */
  async getApps() {
    const options = {
      method: 'GET',
      baseURL: window.apiUrl,
      url: '/apps',
      headers: {
        'Authorization': 'Bearer ' + localStorage.token
      }
    };
    const res = await axios.request(options);
    if (!res.data.success) {
      throw new Error(res.data.error);
    }
    return res.data.apps;
  },

  /**
   * @async
   * @param {string} searchTerm
   * @returns {App[]}
   */
  async searchApps(searchTerm) {
    options = {
      method: 'GET',
      baseURL: window.apiUrl,
      url: '/apps',
      params: {
        q: searchTerm,
      },
      headers: {
        'Authorization': 'Bearer ' + localStorage.token
      }
    };
    const res = await axios.request(options);
    if (!res.data.success) {
      throw new Error(res.data.error);
    }
    return res.data.apps;
  },

  /**
   * @async
   * @param {number} appId
   * @returns {App}
   */
  async getApp(appId) {
    const options = {
      method: 'GET',
      baseURL: window.apiUrl,
      url: '/apps/' + appId,
      headers: {
        'Authorization': 'Bearer ' + localStorage.token
      }
    };
    const res = await axios.request(options);
    if (!res.data.success) {
      throw new Error(res.data.error);
    }
    return res.data.app;
  },

  /**
   * @async
   * @param {number} appId
   * @param {object} fields
   * @param {string} [fields.name]
   * @param {string} [fields.iconUrl]
   */
  async updateApp(appId, fields) {
    const options = {
      method: 'PATCH',
      baseURL: window.apiUrl,
      url: '/apps/' + appId,
      data: fields,
      headers: {
        'Authorization': 'Bearer ' + localStorage.token
      }
    };
    const res = await axios.request(options);
    if (!res.data.success) {
      throw new Error(res.data.error);
    }
  },

  /**
   * @async
   * @param {number} appId
   */
  async deleteApp(appId) {
    const options = {
      method: 'DELETE',
      baseURL: window.apiUrl,
      url: '/apps/' + appId,
      headers: {
        'Authorization': 'Bearer ' + localStorage.token
      }
    };
    const res = await axios.request(options);
    if (!res.data.success) {
      throw new Error(res.data.error);
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/apps/index.js